import { DASHBOARD_COUNTS_LOAD, DASHBOARD_COUNTS_UNLOAD, DASHBOARD_QUEUES_LOAD, DASHBOARD_QUEUES_UNLOAD } from "../constants/actionTypes";

const defaultState = {
  data: {
    new: 0,
    fail: 0,
    counts: 0,
    begin: 0,
  },
  rabbitQueues: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case DASHBOARD_COUNTS_LOAD:
      return {
        ...state,
        data: {
          new: action?.payload?.new ?? 0,
          fail: action?.payload?.fail ?? 0,
          counts: action?.payload?.counts ?? 0,
          begin: action?.payload?.begin ?? 0,
        },
      };
    case DASHBOARD_QUEUES_LOAD:
      return {
        ...state,
        rabbitQueues: Array.isArray(action?.payload) ? action.payload : [],
      };
    case DASHBOARD_COUNTS_UNLOAD:
    case DASHBOARD_QUEUES_UNLOAD:
      return defaultState;
    default:
      return state;
  }
};
